import React from "react";
import SectorDemoTemplate from "./demos/SectorDemoTemplate";
import { SECTOR_CONFIGS } from "./demos/sectorConfigs";

const DemoEstetica = () => <SectorDemoTemplate cfg={SECTOR_CONFIGS.estetica} />;

export default DemoEstetica;
